module.exports = __webpack_public_path__ + "img/body-position-chart-filter.d4c8b10f.gif";